import { useParams } from "react-router-dom";
import NotesTable from "@/features/global/components/NotesTable";
import { useNoteDeepLink } from "@/features/global/components/NotesTable/useNoteDeepLink";
import { useHasCapabilityBool, DOMAIN, PERMISSION } from "@/hooks/useCapabilities";
import { NoteNotableValues } from "@/types";
import { FACILITY_NOTES_QUERY, type FacilityNotesQueryResponse } from "./queries";

export default function FacilityNotesPage() {
  const { facilityId } = useParams();
  const canManageFacility = useHasCapabilityBool({
    domain: DOMAIN.FACILITIES,
    permission: PERMISSION.manageFacilities
  });

  const { highlightNoteId, openNoteId, getCopyLink, setOpenNoteInUrl, tableRef } = useNoteDeepLink({
    dataReady: true
  });

  return (
    <div ref={tableRef}>
      <NotesTable
        variant="top-level"
        notesQuery={FACILITY_NOTES_QUERY}
        queryVariables={{ id: facilityId || "" }}
        selectConnection={(data: FacilityNotesQueryResponse | undefined) => data?.facilityNotes}
        notableTypeFilter={[NoteNotableValues.FACILITY]}
        tableHeading="Facility Notes"
        tableBody="View all notes created for this facility"
        getCopyLink={getCopyLink}
        highlightNoteId={highlightNoteId}
        openNoteId={openNoteId}
        onOpenNoteChange={setOpenNoteInUrl}
        addNoteVariant="filled"
        noteEditing={{
          enabled: canManageFacility,
          notableId: facilityId || "",
          notableType: NoteNotableValues.FACILITY,
          refetchQueries: [FACILITY_NOTES_QUERY],
          objectType: "facility"
        }}
      />
    </div>
  );
}
